import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {ProjectId} from "common/types/project";
import {OrganisationId} from "common/types/organisation";

export default function fetchAllDocuments(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENTS_FETCH_ALL,
    (organisationId: OrganisationId, projectId: ProjectId) => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document_options`,
          {withCredentials: true},
        )
        .then(response => ({
          documents: response.data.data,
          organisationId,
        }));
    },
  );
}
